export const ptBRBills = {
  pageTitle: 'Contas Recorrentes',
  addBill: 'Adicionar Conta',
  createFirstBill: 'Criar Primeira Conta',
  noBillsYet: 'Nenhuma conta recorrente ainda...',
  monthlyTotal: 'Total Mensal',
  filterAll: 'Todas ({{count}})',
  filterActive: 'Ativas ({{count}})',
  filterInactive: 'Inativas ({{count}})',
  filterLabel: 'Filtrar contas',
  noMatchFilter: 'Nenhuma conta corresponde ao filtro atual.',
  errorLoad: 'Erro ao carregar contas: {{error}}',
  modalEditTitle: 'Editar Conta',
  modalAddTitle: 'Adicionar Conta',
  statusEnded: 'Encerrada',
  statusActive: 'Ativa',
  statusPaused: 'Pausada',
  recurrenceMonthly: 'Mensal',
  recurrenceYearly: 'Anual',
  nextDue: 'Proximo vencimento: ',
  installmentsPaid: '{{paid}}/{{total}} parcelas pagas',
  categoryLabel: 'Categoria: ',
  notesLabel: 'Observações',
  accountLabel: 'Conta: ',
  edit: 'Editar',
  end: 'Encerrar',
  delete: 'Excluir',
  deleteTitle: 'Excluir Conta',
  deleteMessage: 'Tem certeza que deseja excluir "{{description}}"? Esta acao nao pode ser desfeita.',
  deleteConfirm: 'Excluir',
  endTitle: 'Encerrar Conta',
  endMessage: 'Tem certeza que deseja encerrar "{{description}}"? A conta sera marcada como encerrada.',
  endConfirm: 'Encerrar Conta',
  perMonth: '/mes',
  formDescriptionLabel: 'Descricao *',
  formDescriptionPlaceholder: 'ex: Assinatura Netflix',
  formAmountLabel: 'Valor *',
  formRecurrenceLabel: 'Recorrencia *',
  formStartDateLabel: 'Data de Inicio *',
  formEndDateLabel: 'Data de Encerramento (opcional)',
  formInstallmentsLabel: 'Total de Parcelas (opcional)',
  formInstallmentsPlaceholder: 'ex: 12',
  formCategoryLabel: 'Categoria (opcional)',
  formNotesLabel: 'Observações (Opcional)',
  formNotesPlaceholder: 'Adicione uma observação sobre esta conta...',
  formAccountLabel: 'Conta de Pagamento (opcional)',
  formRecurrenceMonthly: 'Mensal',
  formRecurrenceYearly: 'Anual',
  formSelectCategory: '-- Selecionar Categoria --',
  formSelectAccount: '-- Selecionar Conta --',
  formCancel: 'Cancelar',
  formSaving: 'Salvando...',
  formUpdate: 'Atualizar Conta',
  formCreate: 'Criar Conta',
  validationDescriptionRequired: 'Descricao e obrigatoria',
  validationDescriptionTooLong: 'Descricao muito longa',
  validationAmountRequired: 'Valor e obrigatorio',
  validationStartDateRequired: 'Data de inicio e obrigatoria',
  validationInstallmentsPositive: 'Parcelas devem ser positivas',
  validationNotesTooLong: 'Observações deve ter no máximo 500 caracteres',
  validationEndDateOrInstallments: 'Nao e possivel especificar data de encerramento e total de parcelas ao mesmo tempo',
  toastCreated: 'Conta criada',
  toastUpdated: 'Conta atualizada',
  toastDeleted: 'Conta excluida',
  toastEnded: 'Conta encerrada',
  toastCreateError: 'Erro ao criar conta',
  toastUpdateError: 'Erro ao atualizar conta',
  toastDeleteError: 'Erro ao excluir conta',
  toastEndError: 'Erro ao encerrar conta',
  noBillsTitle: 'Nenhuma conta recorrente',
  noBillsMessage: 'Acompanhe suas assinaturas e pagamentos recorrentes mensais.',
  files: {
    title: 'Arquivos',
    addFile: 'Adicionar arquivo',
    uploadSuccess: 'Arquivo enviado',
    uploadError: 'Erro ao enviar arquivo',
    deleteConfirm: 'Remover este arquivo?',
    deleteSuccess: 'Arquivo removido',
    deleteError: 'Erro ao remover arquivo',
    tooLarge: 'Arquivo deve ter no maximo 10 MB',
  },
} as const;
